import React, { useState } from 'react';
import { Modal, Button, Form, Input, Select, message } from 'antd';
import { createSubject } from '../../ApiServices/getSubjectService';

const { Option } = Select;

const educationLevelOptions = [
  { label: 'Kindergarten', value: 1 },
  { label: 'Primary School', value: 2 },
  { label: 'Secondary School', value: 3 },
  { label: 'Advanced Secondary School', value: 4 },
  { label: 'College Or University', value: 5 }
];

const CreateSubjectModal = ({ onSubjectCreated }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setVisible(false);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      const subjectData = {
        subject: values.subjectName,
        educationLevels: values.educationLevels
      };

      const response = await createSubject(subjectData);
      console.log('Response:', response.message);
      if (response.code === 200) {
        message.success('Subject created successfully');
        onSubjectCreated();
        handleCancel();
      } else {
        message.error(response.message || 'Failed to create subject');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error(error.response?.data?.message || 'Failed to create subject');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        Create Subject
      </Button>
      
      <Modal
        title="Create New Subject"
        visible={visible}
        onOk={handleSubmit}
        onCancel={handleCancel}
        confirmLoading={loading}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="subjectName"
            label="Subject Name"
            rules={[{ required: true, message: 'Please input the subject name!' }]}
          >
            <Input placeholder="Enter subject name" />
          </Form.Item>
          
          <Form.Item
            name="educationLevels"
            label="Education Levels"
            rules={[{ required: true, message: 'Please select at least one education level!' }]}
          >
            <Select
              mode="multiple"
              placeholder="Select education levels"
              options={educationLevelOptions}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CreateSubjectModal;